import $axios from "@/api";

const state = () => ({
    data: [],
})

const mutations = {
}

const actions = {
    async getListSimple({commit}, filter){
        try{
            const response = await $axios.get("import/list/simple",{params: filter})
            return response.data.data
        }catch(err){    
            console.log(err)
        }
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
